var React = require('react');

function Api (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"api"),React.createElement("g",{"id":"a76e417c-e479-4e26-a6b2-0815398ebb1d","data-name":"Layer 2","key":1},React.createElement("g",{"id":"e2a52f85-f9ce-4b5b-aaa8-fe712c647f63","data-name":"ikonky"},React.createElement("path",{"id":"f9d38de9-df91-4360-bbe2-178e29210806","data-name":"api","d":"M19.46,7.09a7.49,7.49,0,0,0-15,0A5.5,5.5,0,0,0,5.48,18h13a5.5,5.5,0,0,0,1-10.91ZM9.09,8.44V9.85L8.86,10,6.67,11.05l2.19,1.07.23.12v2.09l-.6-.3L4.32,12l-.23-.12V10.23l.23-.11L8.49,8.06l.6-.29Zm4.84-.93-2,8.18L11.8,16H9.9l.13-.51,2.05-8.18L12.15,7h1.91Zm5.16,3v1.37l-.23.12-4.17,2-.6.3V12.24l.23-.12,2.18-1.07L14.32,10l-.23-.12V7.77l.6.29,4.17,2.06.23.11Z"})))]);
}

Api.defaultProps = {"viewBox":"0 0 23.96 18"};

module.exports = Api;

Api.default = Api;
